// extracted by mini-css-extract-plugin
module.exports = {"divider":"FiltersPanel-divider-ef9d","reset":"FiltersPanel-reset-ef9d"};